module.exports = __webpack_public_path__ + "static/media/full.d49286dc.svg";